export const governmentServices = [
  {
    id: 1,
    title: 'City of Roseville',
    description: 'Official city website for services, permits, and information',
    url: 'https://www.roseville.ca.us',
    icon: 'ri-government-line',
    category: 'City Services'
  },
  {
    id: 2,
    title: 'Roseville Police Department',
    description: 'Public safety, crime prevention, and emergency services',
    url: 'https://www.roseville.ca.us/government/departments/police_department',
    icon: 'ri-police-car-line',
    category: 'Public Safety'
  },
  {
    id: 3,
    title: 'Roseville Fire Department',
    description: 'Fire protection, emergency medical services, and prevention',
    url: 'https://www.roseville.ca.us/government/departments/fire',
    icon: 'ri-fire-line',
    category: 'Public Safety'
  },
  {
    id: 4,
    title: 'Roseville Utility Services',
    description: 'Water, electric, and environmental utilities',
    url: 'https://www.roseville.ca.us/government/departments/environmental_utilities',
    icon: 'ri-water-flash-line',
    category: 'Utilities'
  },
  {
    id: 5,
    title: 'Parks & Recreation',
    description: 'Community programs, facilities, and park reservations',
    url: 'https://www.roseville.ca.us/government/departments/parks___recreation',
    icon: 'ri-community-line',
    category: 'Recreation'
  },
  {
    id: 6,
    title: 'Building & Permits',
    description: 'Construction permits, inspections, and planning services',
    url: 'https://www.roseville.ca.us/government/departments/development_services',
    icon: 'ri-file-list-3-line',
    category: 'Development'
  },
  {
    id: 7,
    title: 'Roseville Public Library',
    description: 'Library services, programs, and digital resources',
    url: 'https://www.roseville.ca.us/government/departments/library',
    icon: 'ri-book-open-line',
    category: 'Education'
  },
  {
    id: 8,
    title: 'Placer County',
    description: 'County government services and resources',
    url: 'https://www.placer.ca.gov',
    icon: 'ri-map-pin-line',
    category: 'County Services'
  },
  {
    id: 9,
    title: 'DMV Services',
    description: 'Driver licenses, vehicle registration, and ID cards',
    url: 'https://www.dmv.ca.gov',
    icon: 'ri-car-line',
    category: 'State Services'
  },
  {
    id: 10,
    title: 'Roseville Transit',
    description: 'Public transportation routes and schedules',
    url: 'https://www.roseville.ca.us/government/departments/public_works/transit',
    icon: 'ri-bus-line',
    category: 'Transportation'
  },
  {
    id: 11,
    title: 'Economic Development',
    description: 'Business resources and economic opportunities',
    url: 'https://www.roseville.ca.us/business',
    icon: 'ri-line-chart-line',
    category: 'Business'
  },
  {
    id: 12,
    title: 'Community Services',
    description: 'Senior services, youth programs, and community support',
    url: 'https://www.roseville.ca.us/government/departments/parks___recreation/community_services',
    icon: 'ri-heart-line',
    category: 'Community'
  }
];
